import { PreInterviewForm } from '../shared/form/PreInterviewForm';
import { PreInterviewFormBean } from '../shared/form/PreInterviewForm.types';

export type PreInterviewUpdateFormBean = PreInterviewFormBean;
export const PreInterviewUpdateForm = PreInterviewForm;
